import { useState } from "react";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./HelpModal.module.css";

// Slide content – adjust text/images as needed
const slides = [
    {
        id: "welcome",
        title: "Avencia Homes Help",
        image: "/help/begin.jpg",
        content:
        <>Learn how to customize your home exterior.<br/>Click Start to begin the walkthrough.</>,
        isWelcome: true
    },
        {
        id: "style-size-base",
        title: "Get started",
        image: "/help/tabs.jpg",
        content: <>Select <strong><i>Get Started</i></strong> or <strong><i>My Home</i></strong> to begin.<br/> My Home is your previous saved projects.</>
    },
    {
        id: "get-started",
        title: "Select a Floor Plan",
        image: "/help/select-style.jpg",
              content: (
            <>
                Select a <strong><i>Floor Plan.</i></strong>
            </>
        )
    },
    {
        id: "panel-size",
        title: "Product Menu Tabs",
        image: "/help/panel-size.jpg",
                      content: (
            <>
                Select between the <strong><i>Exterior</i></strong> or <strong><i>Kitchen</i></strong> tabs in the product menu.
            </>
        )
    },
    {
        id: "colors",
        title: "Select a Product Type",
        image: "/help/colors.jpg",
        content:
            (
            <>
            Select a  <strong><i>product tab </i></strong> then select a product to apply to your scene..
            </>
        )
    },
    {
        id: "actions",
        title: "Action Buttons",
        image: "/help/actions.jpg",
        content: (
            <>
            Use the <strong><i>Zoom and Undo/Redo buttons</i></strong> located at the bottom of the pattern panel.
            </>
        )
    },
    {
        id: "view-room",
        title: "Save Project",
        image: "/help/view-room.jpg",
        content:(
            <>
                In the navigation, select <strong><i>Save</i></strong> to save your project. <br/> Select <strong><i>My Home </i></strong>to open previously saved projects.
            </>
        )   
    },

    {
        id: "Print and Copy Link",
        title: "Print Project or Share Link",
        image: "/help/floor.jpg",
        content:(
            <>
                In the navigation, select <strong><i>Print</i></strong> to print or save a pdf of your selected products. <br/> Select <strong><i>Copy Link </i></strong>to share your project link via email or on social sites.
            </>
        )  
    }
    
    //    {
    //     id: "upload-room",
    //     title: "Upload a Custom Room Scene",
    //     image: "/help/upload-scene.jpg",
    //     content:
    //     "Select the Upload Room Scene button at the bottom of the scenes modal to us your own custom image."
    // }
];

export default function HelpModal({ isOpen, onClose }) {
    const [currentSlide, setCurrentSlide] = useState(0);

    if (!isOpen) return null;

    const handleClose = () => {
        setCurrentSlide(0); // reset tutorial
        onClose();
    };

    const handleStart = () => setCurrentSlide(1);

    const handleNext = () => {
        if (currentSlide < slides.length - 1) {
            setCurrentSlide((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentSlide > 0) {
            setCurrentSlide((prev) => prev - 1);
        }
    };

    const slide = slides[currentSlide];
    const isFirstSlide = currentSlide === 0;
    const isLastSlide = currentSlide === slides.length - 1;

    return (
        <PopUpModal
            handleClose={handleClose}
            size="medium"
            title="Help Guide"
            ariaLabelledBy="help-modal-title"
        >
            <div className={styles.mainContent}>
                <div className={styles.slideContainer}>
                    <div className={styles.slideContent}>
                        <h3
                            id="help-modal-title"
                            className={styles.slideTitle}
                        >
                            {slide.title}
                        </h3>

                        {slide.image && (
                            <div
                                className={styles.slideImageContainer}
                            >
                                <img
                                    src={slide.image}
                                    alt={slide.title}
                                    className={styles.slideImage}
                                />
                            </div>
                        )}

                        <p className={styles.slideText}>
                            {slide.content}
                        </p>
                    </div>

                    <div className={styles.slideNavigation}>
                        {isFirstSlide ? (
                            <button
                                className={styles.startButton}
                                onClick={handleStart}
                            >
                                Start
                            </button>
                        ) : (
                            <>
                                <button
                                    className={styles.navButton}
                                    onClick={handlePrev}
                                >
                                    Previous
                                </button>

                                {isLastSlide ? (
                                    <button
                                        className={styles.finishButton}
                                        onClick={handleClose}
                                    >
                                        Finish
                                    </button>
                                ) : (
                                    <button
                                        className={styles.navButton}
                                        onClick={handleNext}
                                    >
                                        Next
                                    </button>
                                )}
                            </>
                        )}
                    </div>

                    <div className={styles.slideIndicator}>
                        {currentSlide + 1} / {slides.length}
                    </div>
                </div>
            </div>
        </PopUpModal>
    );
}


// import PopUpModal from "../PopUpModal/PopUpModal";
// import styles from "./HelpModal.module.css";

// export default function HelpModal({ isOpen, onClose }) {
//     if (!isOpen) return null;

//     return (
//         <PopUpModal 
//             handleClose={onClose}
//             size="medium"
//             title="Help Guide"
//             ariaLabelledBy="help-modal-title"
//         >
//             <div className={styles.contentMain}>
//                 <h2 id="help-modal-title">Active Lines Help</h2>
//                 <div className={styles.content}>
//                     <div className={styles.wrapIt}>
//                         <h4>Get Started</h4>
//                         <div className={styles.wBar}></div>
//                         <p>Select a pattern style to visualize</p>
//                     </div>

//                     <div className={styles.wrapIt}>
//                         <h4>Select a Panel Size</h4>
//                           <div className={styles.wBar}></div>
//                         <p>Choose from 18x18 Tile or 6x36 Plank</p>
//                     </div>

//                     <div className={styles.wrapIt}>
//                         <h4>Choose Base & Accent Colors</h4>
//                         <div className={styles.wBar}></div>
//                         <p>Begin by selecting a base color. Then select color(s) from Running Line or Additional Colors tab </p>
//                     </div>

//                        <div className={styles.wrapIt}>
//                         <h4>Action Buttons</h4>
//                         <div className={styles.wBar}></div>
//                         <p>At the bottom of the pattern panel find the Zoom and Undo/Redo Buttons </p>
//                     </div>

//                     <div className={styles.wrapIt}>
//                         <h4>View in a Room</h4>
//                         <div className={styles.wBar}></div>
//                         <p>Use the toggle at the top of the patten view panel to visualize in a room.  Select the Change Room button to update the room. </p>
//                     </div>

//                     <div className={styles.wrapIt}>
//                         <h4>Main Menu ☰</h4>
//                         <div className={styles.wBar}></div>
//                         <p>Click the ☰ icon at top left to reveil other tool options.  Start Over, Save, Upload Photo, Feedback, Help, Download Image, Share/Email, Print/PDF</p>
//                     </div>
//                 </div>
//             </div>
//         </PopUpModal>
//     );
// }
